module.exports = __webpack_public_path__ + "static/img/slider_light.7b11a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/bba/slider_light.png
// module id = /bzG
// module chunks = 0